import { EmptyStateWithText } from 'components/EmptyState';
import React from 'react';
import styled from 'styled-components';

const Title = styled.h1`
  padding: 16px 0;
  margin-right: 10.5px;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  color: #000000;
`;

const PermissionError: React.VFC<{ pageName?: string; baseData?: boolean }> = ({
  pageName,
  baseData,
}) => (
  <div>
    <EmptyStateWithText
      text={
        'Fehlende Berechtigung' +
        (baseData ? ' für diesen Bereich der Stammdaten.' : '') +
        (pageName ? ' um auf Formular ' + pageName + ' zuzugreifen.' : '')
      }
      verticalPositionTop
    />
  </div>
);

export default PermissionError;
